import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackClickedVideoLoopButton = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedVideoLoopButton = useCallback(() => {
    track(`Clicked loop button in video player`);
  }, [track]);

  return { trackClickedVideoLoopButton };
};
